/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Mac_Dmg_DescInputs */

const en_pc_dl_file_mac_dmg_desc = /** @type {(inputs: Pc_Dl_File_Mac_Dmg_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apple silicon and Intel Macs.`)
};

const zh_pc_dl_file_mac_dmg_desc = /** @type {(inputs: Pc_Dl_File_Mac_Dmg_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于 Apple 芯片和 Intel 芯片的 Mac。`)
};

/**
* | output |
* | --- |
* | "Apple silicon and Intel Macs." |
*
* @param {Pc_Dl_File_Mac_Dmg_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_mac_dmg_desc = /** @type {((inputs?: Pc_Dl_File_Mac_Dmg_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Mac_Dmg_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_mac_dmg_desc(inputs)
	return zh_pc_dl_file_mac_dmg_desc(inputs)
});
export { pc_dl_file_mac_dmg_desc as "pc.dl.file.mac_dmg.desc" }